<template>
  <span>
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M6.49966667,12.5163333 L8.07133333,10.9453333 L10.8893333,13.7623333 L10.8893333,2 L13.1113333,2 L13.1113333,13.7623333 L15.9283333,10.9453333 L17.5006667,12.5163333 L12.7856667,17.23 C12.3526667,17.6643333 11.6486667,17.6643333 11.2146667,17.23 L6.49966667,12.5163333 Z M19.7776667,15.3333333 L22,15.3333333 L22,19.778 C22,20.9993333 20.9996667,22 19.7776667,22 L4.22233333,22 C3.00033333,22 2,20.9993333 2,19.778 L2,15.3333333 L4.22233333,15.3333333 L4.22233333,19.778 L19.7776667,19.778 L19.7776667,15.3333333 Z" id="path-1-download-icon"></path>
      </defs>
      <g id="icons/download" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
        <mask id="mask-2-download-icon" fill="white">
          <use xlink:href="#path-1-download-icon"></use>
        </mask>
        <use id="Combined-Shape" :fill="fill" fill-rule="nonzero" xlink:href="#path-1-download-icon"></use>
        <g id="Mixin/Fill/Black" mask="url(#mask-2-download-icon)" :fill="fill">
          <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
        </g>
      </g>
    </svg>
  </span>
</template>

<script>
export default {
  name: "DsDownloadIcon",
  props: {
    fill: {
      type: String,
      default: "#1da1f2"
    }
  }
};
</script>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-download-icon.vue